import React from "react";
import styled, { css } from "styled-components";
import { vi } from "../../data";
import {
  Button,
  FormGroup,
  ContentBlock,
  Dropdown,
  TagSelector,
  Icon,
  Select,
  Input,
  Switch,
  RadioGroup,
  FormFooter,
  Tag,
  Tooltip,
  Table,
  FormCaption
} from "xsolla-uikit";

import {
  PAvCpreview,
  PAinfoCollapsible,
  CssVCimage,
  CssVCimages,
  CssSquareButton,
  CssThTd
} from "../uikit2";

export const defGroups = [
  {
    name: 'All',
    id: '1223',
    shown: true,
    // items: vi,
    items: ()=>{
      let arr = [...vi].length = 4;
      return arr
    }
  },
  {
    name: 'Weapons',
    id: '1414',
    shown: true,
    items: vi,
    // items: ()=>{
    //   let arr = [...vi].length = 16;
    //   return arr
    // }
  },
  {
    name: 'Shields',
    id: '7476',
    shown: true,
    items: vi,
    // items: ()=>{
    //   let arr = [...vi].length = 12;
    //   return arr
    // }
  },
  {
    name: 'Tools',
    id: '5234',
    shown: true,
    items: vi,
    // items: ()=>{
    //   let arr = [...vi].length = 24;
    //   return arr
    // }
  },
  {
    name: 'Stickers',
    id: '5234',
    shown: true,
    items: vi,
    // items: ()=>{
    //   let arr = [...vi].length = 12;
    //   return arr
    // }
  },
]








export const PAstoreGroups = ({
  active,
  handleEdit,
  handleClick,
  groups = [...defGroups],
}) => {
  return (<CssGroupsGrid>
    {groups.map((oneGroup, ind) => {
      return (<PAviGroupOne
        key={`group_${ind}`}
        active={active} handleClick={handleClick} handleEdit={handleEdit} {...oneGroup} />);
    })}
  </CssGroupsGrid>);
};







export const PAviGroupOne = ({
  active,
  handleEdit,
  handleClick = ()=>void(0),
  name = 'All',
  id = '1223',
  image_url,
  shown = true,
  items = [],
}) => {
  return (<CssGroup
  active={active === id ? true : false}
  className="virtual-items-row__name" onClick={handleClick ? ()=>handleClick(id) : ()=>void(0)}>

      {handleEdit && <CssEdit onClick={(e) => handleEdit(id, e)}><Icon size={20} name='build'/></CssEdit>}

      {!image_url && <img className="virtual-items-row__name__image" src="//cdn.xsolla.net/publisher-v4/folder.17729c.svg" />}
      {!!image_url &&
      <div style={{marginRight: 16}}>
      <CssVCimages
        style={{width: 64, height: 64}}
        amount={1}
        image_url={image_url}
      /></div>}

      <div className="virtual-items-row__name__info">
        {name}
      <div data-id="vi.group.info">
        ID: {id}<br/>
        Total items: {items.length}</div>
    </div>
  </CssGroup>)
}


export const CssGroupsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 22%));
  grid-row-gap: 36px;
  grid-column-gap: 24px;
`

export const CssEdit = styled.span`
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 2;
  display: flex;
  align-items: center;
  padding-left: 8px;
  border-left: 1px solid #c5d0db;
  font-size: 14px;
  color: #747e8a;
  &:hover,&:hover div, &:hover span {
    color: #0073f7;
  }
`

export const CssGroup = styled.div`
  cursor: pointer;
  position: relative;
  transition: all 150ms ease-in-out;
  & div {
    z-index:1;
  }
  &::before {
        border-radius: 6px;
        transition: all 150ms ease-in-out;
        content: '';
        text-transform: none;
        position: absolute;
        bottom: -6px;
        min-height: 16px;
        top: -8px;
        left: -6px;
        right: -6px;
        bottom: -8px;
        z-index:0;
  }
  &:hover {
    color: #0073f7;
    &::before {
      background-color: #d4e5ff38;
      /* border: 1px solid #0073f7; */
      border: 1px solid #0073f7;
    }
  }

  ${({active})=> !!active && css`
    /* &:hover { */
        &::before {
          background-color: #d4e5ff38;
        }
      /* } */
  `}

`
